import angular from 'angular';
import { AbstractDataProviderV2 } from 'components/system';
import { RsCustomerVaccination } from 'common/customers/services/types/RsCustomerVaccination';
import { CustomerUpdateVaccination } from 'common/customers/services/types/CustomerUpdateVaccination';
import { A9Service } from 'components/system/angular/A9Service';

export class CustomerVaccinationDataProvider extends AbstractDataProviderV2<void, RsCustomerVaccination, void, CustomerUpdateVaccination> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/vaccination');
    }

    public setProof(customerId: number, file: File): PromiseLike<void> {
        const fd = new FormData();
        fd.append('fileData', file);
        return this.service
            .http({
                method: 'POST',
                url: `middle://rs/customers/${customerId}/vaccination/proof`,
                data: fd,
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                },
                params: {}
            })
            .then(response => {})
            .catch(error => {
                throw new Error(error.message);
            });
    }

    public setShare(customerId: number, file: File): PromiseLike<void> {
        const fd = new FormData();
        fd.append('fileData', file);
        return this.service
            .http({
                method: 'POST',
                url: `middle://rs/customers/${customerId}/vaccination/share`,
                data: fd,
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                },
                params: {}
            })
            .then(response => {})
            .catch(error => {
                throw new Error(error.message);
            });
    }

    public removeShare(customerId: number): Promise<void> {
        return this.service
            .updateRequest('middle://rs/customers/' + customerId + '/vaccination/share', 'DELETE')
            .then(responseData => {})
            .catch(err => {
                return Promise.reject(err);
            });
    }

    public removeProof(customerId: number): Promise<void> {
        return this.service
            .updateRequest('middle://rs/customers/' + customerId + '/vaccination/proof', 'DELETE')
            .then(responseData => {})
            .catch(err => {
                return Promise.reject(err);
            });
    }

    public list() {
        return Promise.reject('Method `list` is not available');
    }

    public add() {
        return Promise.reject('Method `add` is not available');
    }

    public patch() {
        return Promise.reject('Method `patch` is not available');
    }

    public remove() {
        return Promise.reject('Method `remove` is not available');
    }
}
